import { render, staticRenderFns } from "./EditBtn.vue?vue&type=template&id=76bd31a7&"
import script from "./EditBtn.vue?vue&type=script&lang=ts&"
export * from "./EditBtn.vue?vue&type=script&lang=ts&"
import style0 from "./EditBtn.vue?vue&type=style&index=0&id=76bd31a7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports